import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { defaultRiskLevels } from '../constants';
import { SliderInputOptions } from './slider-input';

@Component({
  selector: 'libero-slider-input',
  templateUrl: './slider-input.component.html',
  styleUrls: ['./slider-input.component.scss'],
  standalone: false
})
export class SliderInputComponent implements OnInit, OnDestroy {
  @Input() public options!: SliderInputOptions;
  @Input() public formName!: AbstractControl;
  @Input() public disabled = false;

  public currentValueDebouncer = new Subject<string>();
  public currentValue = 0;
  public defaultRiskLevels = defaultRiskLevels;

  public ngOnInit(): void {
    this.currentValueDebouncer.pipe(
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe(value => {
        if(this.formName) {
          this.currentValue = parseInt(value);
          this.formName.patchValue(value);
          this.formName.markAsTouched();
          this.formName.markAsDirty();
        }
      }
    );

    this.initValue();
  }

  private initValue(): void {
    if (this.formName && this.formName.value) {
      this.currentValue = this.formName.value;
    }
  }

  public sliderInputUpdated(event: Event): void {
    if ((event?.target as HTMLInputElement)?.value) {
      const sliderNewValue = (event.target as HTMLInputElement).value as unknown as number;
      this.updateValue(sliderNewValue);
    }
  }

  public updateValue(newValue: number): void {
    this.currentValue = newValue;
    this.currentValueDebouncer.next(newValue.toString());
  }

  public ngOnDestroy(): void {
    this.currentValueDebouncer.unsubscribe();
  }
}
